import React, {useEffect, useState} from 'react';

import IconSVG from 'components/icons/IconSVG';
import RadioSet from 'components/forms/elements/RadioSet';
import TextArea from 'components/forms/elements/TextArea';
import Button from 'components/forms/elements/Button';
import Control from 'components/atoms/Control';

export default (props) => {
	const [active, setActive] = useState(null);
	const [approvalStatus, setApprovalStatus] = useState(null);
	const [approvalMessage, setApprovalMessage] = useState(null);
	const [approvalReady, setApprovalReady] = useState(null);
	const [approvalSet, setApprovalSet] = useState(null);
	const [btnLabel, setBtnLabel] = useState(props.site.translation && props.site.translation.products.labels.select_approval);
	const [clearMessage, setClearMessage] = useState(false);
	const [showInstruction, setShowInstruction] = useState(true);
	
	useEffect(() => {
		if(props.approval) {
			if(props.approval.approval_status &&
				props.approval.approval_status !== approvalStatus) {
				setApprovalStatus(props.approval.approval_status);
			}
			
			if(props.approval.approval_message &&
				props.approval.approval_message !== approvalMessage) {
				setApprovalMessage(props.approval.approval_message);
			}
			
			if(props.approval.approval_date) {
				setApprovalSet(true);
				setApprovalReady(true);
				setBtnLabel(props.site.translation && props.site.translation.labels.complete);
			}
		}	
	}, [props.approval]);
	
	useEffect(() => {
		switch(approvalStatus) {
			case 'approved':
				setApprovalReady(true);
				setBtnLabel(props.site.translation && props.site.translation.labels.submit);
				break;
			case 'proof_required':
				if(approvalMessage) {
					setApprovalReady(true);
					setBtnLabel(props.site.translation && props.site.translation.labels.submit);
				}else {
					setApprovalReady(false);
					setBtnLabel(props.site.translation && props.site.translation.products.labels.provide_instructions)
				}
				break;
			default:
				if(approvalReady) {
					setApprovalReady(false);
					setBtnLabel(props.site.translation && props.site.translation.products.labels.select_approval);
				}
				break;
		}
	}, [approvalStatus, approvalMessage]);
	
	function handleStatus(params) {
		if(params.value && params.value !== approvalStatus) {
			setApprovalStatus(params.value);
		}
	}
	
	function handleComment(params) {
		setClearMessage(false);
		if(params.value === '') {
			setApprovalMessage(null);
		}else{
			setApprovalMessage(params.value);
		}
	}
	
	function resetApproval() {
		setApprovalStatus(null);
		setApprovalMessage(null);
		setClearMessage(true);
		setApprovalSet(false);
		if(props.actionClear) {
			props.actionClear();
		}
	}
	
	function handleApproval() {
		if(approvalReady && !approvalSet) {
			setApprovalSet(true);
			setBtnLabel(props.site.translation && props.site.translation.labels.complete);
			
			if(props.actionApprove) {
				props.actionApprove({
					approval_status: approvalStatus,
					approval_message: approvalMessage
				});
			}
		} 
	}
	
	return (
		<div className={`block-border info-border${active ? ` active` : ''}`}
			style={{
				borderWidth: '.25em',
				borderRadius: '.5em'
			}}>
			
			<div className="info-block info-bg" 
				style={{
					display: 'flex',
					alignItems: 'flex-start',
					flexWrap: 'wrap'
				}}>
				<IconSVG icon="view-file" 
						className="white"
						style={{
							marginRight: '.5em',
							flex: `0 0 ${showInstruction ? '2em' : '1em'}`,
							height: showInstruction ? '2em' : '1em'
						}} />
				<div style={{
					flex: '1 0 13em'
				}}>
					<b style={{fontSize: '1.25em', lineHeight: '1'}}>{props.site.translation && props.site.translation.products.alerts.requires_approval}</b>
					<div className={`expandable${showInstruction ? ' active' : ''}`}>
						{props.site.translation && props.site.translation.products.alerts.review_carefully} <b>{props.site.translation && props.site.translation.products.labels.approved_proceed}</b>.<br />
						{props.site.translation && props.site.translation.products.alerts.editing_or_select} <b>{props.site.translation && props.site.translation.products.labels.additional_proof_required}</b> {props.site.translation && props.site.translation.products.alerts.supply_instructions}
					</div>
				</div>
				<div style={{flex: '0 0 100%', display: 'flex', justifyContent: 'flex-end'}}>
					<Control icon={showInstruction ? 'collapse' : 'expand'}
							iconClass="no-btn"
							label={showInstruction ? props.site.translation && props.site.translation.products.labels.hide_instructions : props.site.translation && props.site.translation.products.labels.show_instructions}
							showLabel={true}
							style={{opacity: 1, margin: '0em', marginTop: '.5em'}}
							className="white subtext"
							action={()=>{setShowInstruction(showInstruction ? false : true)} } />
				</div>
			</div>
			<div className="form-row" style={{justifyContent: 'center'}}>
				<RadioSet {...props}
					name="approval_status"
					option_groups={[{options: [
						{option_name: props.site.translation && props.site.translation.products.labels.approved_proceed, option_value: 'approved'},
						{option_name: props.site.translation && props.site.translation.products.labels.additional_proof_required, option_value: 'proof_required'}	
					]}]}
					value={approvalStatus}
					onChange={handleStatus}
					
					/>	
			</div>
			<div className="form-row">
				<TextArea {...props}
					name="approval_comment"
					label={props.site.translation && props.site.translation.products.labels.instructions}
					placeholder={props.site.translation && props.site.translation.products.placeholders.provide_details}
					value={approvalMessage}
					required={true}
					onChange={handleComment}
					clearContents={clearMessage}
					/>	
			</div>
			<div className="form-row" style={{justifyContent: 'center'}}>
				<Button icon={approvalReady ? `check` : `caution`}
					label={btnLabel}
					btnClass={`lg ${approvalReady ? 'success-bg' : 'caution-bg'}`}
					disabled={approvalReady && !approvalSet ? false : true}
					btnAction={handleApproval} />
			</div>
			<div className="form-row" style={{justifyContent: 'center'}}>
				<Control icon="refresh" 
					label={props.site.translation && props.site.translation.products.labels.clear_approval}
					iconClass="no-btn"
					showLabel={true} 
					action={resetApproval} />
			</div>
		</div>
	)
}